import type { Money } from '@shared/api';

const NUMBER_FORMATTERS = new Map<string, Intl.NumberFormat>();

function getFormatter(currency: string, locale: string): Intl.NumberFormat {
  const key = `${locale}:${currency}`;
  let fmt = NUMBER_FORMATTERS.get(key);
  if (!fmt) {
    fmt = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: 2,
    });
    NUMBER_FORMATTERS.set(key, fmt);
  }
  return fmt;
}

export function MoneyDisplay({
  money,
  locale,
  fallback = '—',
}: {
  money: Money | null | undefined;
  locale?: string;
  fallback?: string;
}) {
  if (!money) return <>{fallback}</>;
  const amount = Number(money.amount);
  if (!Number.isFinite(amount)) return <>{fallback}</>;
  const detectedLocale = locale ?? (typeof navigator !== 'undefined' ? navigator.language : 'en');
  try {
    return <>{getFormatter(money.currency, detectedLocale).format(amount)}</>;
  } catch {
    return <>{`${amount.toFixed(2)} ${money.currency}`}</>;
  }
}
